import { RegistrationStepType, ValidStepsType } from '../types';

export const getFirstServerErrorStep = (validSteps: ValidStepsType) => {
  const [step] =
    Object.entries(validSteps).find(([, isValid]) => !isValid) || [];

  return (Number(step) || 1) as RegistrationStepType;
};
